import { stats } from '../mock';
import { useAnimatedCounter } from '../hooks/useAnimatedCounter';

export const Counter = ({ value, label }) => {
  const [ref, display] = useAnimatedCounter(value);
  return (
    <div ref={ref} data-testid={`stat-${label.toLowerCase().replace(/\s+/g, '-')}`} className="flex flex-col items-center text-center">
      <div className="text-[26px] sm:text-[34px] lg:text-[42px] font-semibold text-clay leading-none tracking-tight whitespace-nowrap">{display}</div>
      <div className="mt-3 text-[9px] sm:text-[10px] tracking-[0.24em] text-white/55">{label}</div>
    </div>
  );
};

const Stats = () => (
  <section className="relative -mt-24 z-20 px-6 lg:px-10">
    <div className="max-w-[1300px] mx-auto rounded-2xl bg-card/95 backdrop-blur-xl border border-border px-5 sm:px-10 py-8 sm:py-12 grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
      {stats.map((stat, index) => (
        <div key={stat.label} className="relative">
          <Counter value={stat.value} label={stat.label} />
          {index < stats.length - 1 && <span className="hidden lg:block absolute right-0 top-1/2 -translate-y-1/2 h-8 w-px bg-white/10" />}
        </div>
      ))}
    </div>
  </section>
);

export default Stats;